export default __webpack_public_path__ + "static/media/LincolnBG.f8113f86.png";